module.exports = __webpack_public_path__ + "static/media/larnrod-eireann-irish-rail.d25d7a8e.jpg";